import {action} from 'typesafe-actions'
import {RequestData} from "@models/axios";
import {Ticket} from "@models/ticket";

export const enum TicketsActionTypes {
    FETCH_REQUEST = '@@tickets/FETCH_REQUEST',
    FETCH_SUCCESS = '@@tickets/FETCH_SUCCESS',
    FETCH_ERROR = '@@tickets/FETCH_ERROR',

    UPDATE_REQUEST = '@@tickets/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@tickets/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@tickets/UPDATE_ERROR',

    FETCH_ITEM_REQUEST = "@@tickets/FETCH_ITEM_REQUEST",
    FETCH_ITEM_SUCCESS = "@@tickets/FETCH_ITEM_SUCCESS",
    FETCH_ITEM_ERROR = "@@tickets/FETCH_ITEM_ERROR",

    FETCH_PENDING_REQUEST = '@@tickets/FETCH_PENDING_REQUEST',
    FETCH_PENDING_SUCCESS = '@@tickets/FETCH_PENDING_SUCCESS',
    FETCH_PENDING_ERROR = '@@tickets/FETCH_PENDING_ERROR',
}


export const fetchRequest = (data: RequestData) => action(TicketsActionTypes.FETCH_REQUEST, data);
export const fetchSuccess = (data: Ticket[]) => action(TicketsActionTypes.FETCH_SUCCESS, data);
export const fetchError = (message: string) => action(TicketsActionTypes.FETCH_ERROR, message);

export const updateRequest = (data: RequestData) => action(TicketsActionTypes.UPDATE_REQUEST, data);
export const updateSuccess = (data: RequestData) => action(TicketsActionTypes.UPDATE_SUCCESS, data);
export const updateError = (message: string) => action(TicketsActionTypes.UPDATE_ERROR, message);


export const fetchItemRequest = (data: RequestData) => action(TicketsActionTypes.FETCH_ITEM_REQUEST, data);
export const fetchItemSuccess = (data: Ticket[]) => action(TicketsActionTypes.FETCH_ITEM_SUCCESS, data);
export const fetchItemError = (message: string) => action(TicketsActionTypes.FETCH_ITEM_ERROR, message);

export const fetchPendingTicketsRequest = (data: RequestData) => action(TicketsActionTypes.FETCH_PENDING_REQUEST, data);
export const fetchPendingTicketsSuccess = (data: RequestData) => action(TicketsActionTypes.FETCH_PENDING_SUCCESS, data);
export const fetchPendingTicketsError = (message: string) => action(TicketsActionTypes.FETCH_PENDING_ERROR, message);




